import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {IAddressValidationResponse} from '../common-interfaces';
import {ICountry} from '../components/address/country';
import {IState} from '../country-states-service';


@Component({
    selector: 'address-override-confirm-dialog',
    templateUrl: './address-override-confirm-dialog.component.html',
    styleUrls: ['./address-override-confirm-dialog.component.scss'],
    standalone: false
})
export class AddressOverrideConfirmDialogComponent {

  fullAddress: string;
  private states: IState[];
  private countries: ICountry[];

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: {
      addressValidationResponse: IAddressValidationResponse,
      states: IState[],
      countries: ICountry[],
    },
  ) {
    this.states = data.states;
    this.countries = data.countries;

    const addr = data.addressValidationResponse;

    this.fullAddress = addr.address + ', ' + addr.city + ', ' + this.getStateAbbreviation(addr.stateId) +
      ', ' + addr.zip + ', ' + this.getCountryName(addr.countryId);

  }

  private getCountryName(id: number): string {
    return this.countries.filter(item => `${item.id}` === `${id}`)[0].countryName;
  }

  private getStateAbbreviation(id: number): string {
    return this.states.filter(item  => `${item.id}` === `${id}`)[0]?.abbreviation;
  }

}
